import UBT from '@hotelcem/utils/matomoUbt'

/*
需要埋点的元素 添加 class: mtm-click,添加 data-click-type: 触发埋点的类型
例子： data-click-type="JSON.stringify({ page: '/hotelcem/voice-analysis/index', action: 'tabs' })"
*/
function getClickType(dom) {
  let target = dom.closest('.mtm-click')
  if (target) {
    return target.dataset.clickType
  }
  return null
}

if (window?.addEventListener) {
  window.addEventListener('click', function (e) {
    let clickType = getClickType(e.target)
    if (clickType) {
      UBT.sendEvent('clickMtmTrigger', {
        clickType,
      })
    }
  })
}
